import { useModuleGate } from '../../../lib/moduleGate';

/**
 * True when the track page should say why its one thing to do now matters
 * (TrackProgress). The progress strip and the call to action themselves are
 * part of the track page and draw either way.
 *
 * Canonical gate (build contract §2.7): the `story_overlay` workspace module
 * with its paired flag, resolved through useModuleGate. Like every module it
 * starts on (ruling 2026-10-14); it exists for sales and education workspaces
 * (ruling 2026-10-20), so a workspace admin switches it off in Settings →
 * Modules where it is not wanted.
 */
export function useStoryOverlayEnabled(): boolean {
  return useModuleGate('story_overlay');
}
